import React, { useState } from 'react';
import { formatDecimals, formatNumber } from '../../utils';
import { Flexbox, FlexboxColumn } from '../action/Flexbox';
import ThemedText from '../theme/ThemedText';
import AnalysisTableSkeleton from './AnalysisTableSkeleton';
import './PositionAnalysis.scss';

const AnalysisTable = ({ userData, compareData, switchOn, projectData, isChain }) => {
  const [isHovering, setIsHovering] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  const headers = ['Volume', 'Transactions'];

  const handleHover = value => {
    if (!isExpanded) {
      setIsHovering(value);
    }
  };

  function handleExpanding() {
    setIsHovering(false);
    setIsExpanded(prev => !prev);
  }

  function formatActionTags(actionTags) {
    if (!Array.isArray(actionTags) || actionTags.length === 0) {
      return '';
    }
    const capitalizedTags = actionTags.map(tag => tag.charAt(0).toUpperCase() + tag.slice(1));
    if (capitalizedTags.length === 1) {
      return capitalizedTags[0];
    }
    return capitalizedTags.slice(0, -1).join(', ') + ' & ' + capitalizedTags[capitalizedTags.length - 1];
  }

  if (!userData || (switchOn && !compareData)) return <AnalysisTableSkeleton />;
  return (
    <FlexboxColumn className='analysistable_wrapper' fw gap='0' onMouseEnter={() => handleHover(true)} onMouseLeave={() => handleHover(false)} onClick={handleExpanding}>
      <Flexbox className='analysistable_wrapper__header' fw justifyContent='flex-start'>
        <Flexbox className='analysistable_wrapper__stats' justifyContent='flex-start'>
          <ThemedText.H5 weight='semi-bold'>{projectData ? formatActionTags(projectData?.actionTags) : isChain ? 'Swap & Bridge' : ''}</ThemedText.H5>
        </Flexbox>
        <Flexbox className='analysistable_wrapper__data'>
          {headers.map(item => (
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row' key={`analysistable_wrapper__header_${item}`}>
              <ThemedText.H5 weight='semi-bold'> {item}</ThemedText.H5>
              {/* <ThemeLogo icon={'sort'} /> */}
            </Flexbox>
          ))}
        </Flexbox>
        {switchOn && compareData && (
          <Flexbox className='analysistable_wrapper__data compared'>
            {headers.map(item => (
              <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row' key={`analysistable_wrapper__data_${item}`}>
                <ThemedText.H5 weight='semi-bold'> {item}</ThemedText.H5>
                {/* <ThemeLogo icon={'sort'} /> */}
              </Flexbox>
            ))}
          </Flexbox>
        )}
        {/* <Flexbox className='analysistable_wrapper__action'>
          <ThemeLogo icon={'addCircle'} />
        </Flexbox> */}
      </Flexbox>

      <Flexbox className='analysistable_wrapper__row' fw>
        <Flexbox className='analysistable_wrapper__stats' justifyContent='flex-start'>
          {/* <Logo width={'1.5rem'} height={'1.5rem'} borderRadius='50%' src={'https://picsum.photos/id/4/200/300'} /> */}
          <ThemedText.P>Total</ThemedText.P>
        </Flexbox>
        <Flexbox className='analysistable_wrapper__data'>
          <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
            <ThemedText.P> ${formatNumber(formatDecimals(userData?.volume))}</ThemedText.P>
          </Flexbox>
          <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
            <ThemedText.P> {parseInt(userData?.txnCount)}</ThemedText.P>
          </Flexbox>
        </Flexbox>
        {switchOn && compareData && (
          <Flexbox className='analysistable_wrapper__data compared_data'>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row compared'>
              <ThemedText.P> ${formatNumber(formatDecimals(compareData?.volume))}</ThemedText.P>
            </Flexbox>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row compared'>
              <ThemedText.P> {parseInt(compareData?.txnCount)}</ThemedText.P>
            </Flexbox>
          </Flexbox>
        )}
        {/* <Flexbox className='analysistable_wrapper__action'></Flexbox> */}
      </Flexbox>

      {/* {!isExpanded && (
        <Flexbox className={`analysistable_wrapper__hoverRow ${isHovering ? 'show' : ''}`} fw>
          <Flexbox className='analysistable_wrapper__stats' justifyContent='flex-start'>
            <Logo width={'1.5rem'} height={'1.5rem'} borderRadius='50%' src={'https://picsum.photos/id/4/200/300'} />
            <ThemedText.P>Swap</ThemedText.P>
          </Flexbox>
          <Flexbox className='analysistable_wrapper__data'>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> $8200</ThemedText.P>
            </Flexbox>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> 8100</ThemedText.P>
            </Flexbox>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> 150</ThemedText.P>
            </Flexbox>
          </Flexbox>
          <Flexbox className='analysistable_wrapper__action'></Flexbox>
        </Flexbox>
      )} */}

      {/* <FlexboxColumn gap='0' className={`analysistable_wrapper__expandable ${isExpanded ? 'expanded' : ''}`}>
        <Flexbox className='analysistable_wrapper__row' fw>
          <Flexbox className='analysistable_wrapper__stats' justifyContent='flex-start'>
            <Logo width={'1.5rem'} height={'1.5rem'} borderRadius='50%' src={'https://picsum.photos/id/4/200/300'} />
            <ThemedText.P>Swap</ThemedText.P>
          </Flexbox>
          <Flexbox className='analysistable_wrapper__data'>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> $8200</ThemedText.P>
            </Flexbox>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> 8100</ThemedText.P>
            </Flexbox>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> 150</ThemedText.P>
            </Flexbox>
          </Flexbox>
          <Flexbox className='analysistable_wrapper__action'></Flexbox>
        </Flexbox>
        <Flexbox className='analysistable_wrapper__row' fw>
          <Flexbox className='analysistable_wrapper__stats' justifyContent='flex-start'>
            <Logo width={'1.5rem'} height={'1.5rem'} borderRadius='50%' src={'https://picsum.photos/id/4/200/300'} />
            <ThemedText.P>Bridge</ThemedText.P>
          </Flexbox>
          <Flexbox className='analysistable_wrapper__data'>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> $8200</ThemedText.P>
            </Flexbox>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> 8100</ThemedText.P>
            </Flexbox>
            <Flexbox gap='0.75rem' justifyContent='flex-start' className='analysistable_wrapper__data__row'>
              <ThemedText.P> 150</ThemedText.P>
            </Flexbox>
          </Flexbox>
          <Flexbox className='analysistable_wrapper__action'></Flexbox>
        </Flexbox>
      </FlexboxColumn> */}
    </FlexboxColumn>
  );
};

export default AnalysisTable;
